/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { useTheme } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import axios from "../utils/axiosConfig";
import axiosInstance from "axios";

import Grid from "@mui/material/Grid";

import Dialog from "@mui/material/Dialog";
import Transition from "../components/Test/Transition";

import TestAppBar from "../components/Test/AppBar";
import MultipleanswerAllCorrect from "../components/Test/QuestionAnswerType/MultipleAnswerAllCorrect";
import MultipleSelectAnswer from "../components/Test/QuestionAnswerType/MultipleSelectAnswer";
import Passage from "../components/Test/QuestionAnswerType/PassageMultipleChoiseQuestion";

import Proceed from "../components/Test/Proceed";

import WindowFocusHandler from "../components/WindowFocusHandler";
import CopyPasteHandler from "../components/Test/CopyPasteHandler";
import FullscreenHandler from "../components/Test/FullscreenHandler";
import TimeOutModal from "../components/Test/TimeOutModal";
import TimeOutModalOneMinute from "../components/Test/TimeOutOneMinuteModal";

import FinishModal from "../components/Test/FinishModal";
import FinishModalDetail from "../components/Test/FinishModalDetail";
import LastQuestionModal from "../components/Test/LastQuestionModal";
import InstructionPage from "../components/Test/Instruction";
import ThankyouPage from "../components/Test/Thankyou";
import FillInTheBlank from "../components/Test/QuestionAnswerType/FillInTheBlank";
import DescriptiveAnswer from "../components/Test/QuestionAnswerType/DescriptiveAnswer";
import TypingTest from "../components/Typing/typyingTest";
import DifferenceBetween from "../components/Test/QuestionAnswerType/DifferenceBetween";
import MatchTheColumn from "../components/Test/QuestionAnswerType/MatchTheColumn";
import SpeechEvaluation from "../components/Test/QuestionAnswerType/RecordRtc";
import ImageProct from "../components/Test/ImageProctoring";
import BackgroundAudioRecorder from "../components/Test/BackgroundAudioRecorder";
import AudioAlertModal from "../components/Test/AudioAlertModal";
import SpeechAlertModal from "../components/Test/SpeechAlertModal";
import { audioCheckMode } from "../utils/headphonesAllowed";
import AutoSpeech from "../components/Test/QuestionAnswerType/AutoSpeech";
import MultipleFillInTheBlank from "../components/Test/QuestionAnswerType/MultiFillInTheBlank";
import EnterMarksPattern from "../components/Test/QuestionAnswerType/EnterMarksPattern";
import VideoInterview from "../components/Test/QuestionAnswerType/VideoInterview";
import Simulator from "../components/Test/QuestionAnswerType/CodingSimulator";
import { resultBaseURL } from "../utils/constants";
import onFinishSaveToMongoFunction from "../utils/onFinishSaveToMongoFunction";
import heartbeatSaveFunction from "../utils/heartbeatSaveFunction";
import ResponseIssueModal from "../components/Test/ResponseIssueModal";
import postWithRetry from "../utils/postWithRetry";
import { savePendingSubmission } from "../utils/indexedDBStorage";
import onWindowReload from "../utils/reloadFunction";
import { isFaceNotFoundBudgetExceeded } from "../utils/faceNotFoundBudget";
import { isWarningLimitExceeded } from "../utils/proctoringWarningLimit";
import { ACTIVE_STAMP_MS, markTestActive } from "../utils/proctoringSession";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  title: {
    flexGrow: 1,
  },
  overlay: {
    overflow: "inherit",
    position: "initial",
    padding: "0px",
    inset: "40px",
    border: "1px solid rgb(204, 204, 204)",
    background: "rgb(255, 255, 255)",
    borderRadius: "4px",
    outline: "none",
  },
}));


export default (props) => {
  const _classes = useStyles();
  const _theme = useTheme();
  const { examId, setTestData, _resumeTest, _setResumeTest, _closeModal, codeLanguages } = props;

  let testData = props.testData.quesData;
  let examDetail = props.testData.examDetail;
  const workflowContext = props.testData.workflowContext || null;

  if (testData === undefined || examDetail === undefined) {
    let data = window.localStorage.getItem(examId);
    if (data !== null) {
      let decodedData = decodeURIComponent(atob(decodeURIComponent(data)));
      let stringifyDecodedData = JSON.stringify(decodedData);
      let parsedData = JSON.parse(stringifyDecodedData);
      examDetail = JSON.parse(parsedData)[0].examDetail;
      testData = JSON.parse(parsedData)[0].quesData;
      setTestData({ quesData: JSON.parse(parsedData)[0].quesData, examDetail: JSON.parse(parsedData)[0].examDetail });
    }
  }

  // React 18: Guard against concurrent rendering - examDetail might not be ready yet
  // Ensure time_remaining is always valid (not null, undefined, or empty)
  if (examDetail && Array.isArray(examDetail) && examDetail.length > 0) {
    const timeRemaining = examDetail[0].time_remaining;
    const isValidTimeRemaining = timeRemaining !== null && timeRemaining !== undefined && timeRemaining !== "" && !isNaN(Number(timeRemaining));
    if (!isValidTimeRemaining) {
      // Never fabricate a small number here - a `1` reads as "already expired" to the
      // backend's own validity check (it's a technically-valid number, so none of the
      // backend's null/NaN fallback logic catches it), turning a missing local value
      // into a real false timeout on this candidate's next resume/refresh. Full
      // allotted duration in both cases, same as everywhere else this was fixed.
      const totalTestTime = examDetail[0].total_test_time || (examDetail[0].instanceduration * 60);
      examDetail[0].time_remaining = totalTestTime;
      examDetail[0].time_left = totalTestTime;
      console.log("Investigate: time_remaining null in Test.jsx - falling back to full allotted duration:", totalTestTime);
    }
  }

  const [value, setValue] = React.useState(0);

  const [questionNo, setQuestionNo] = React.useState(1);

  const [windowSwitchCount, setWindowSwitch] = React.useState(0);

  // Rehydrate from whatever was last persisted to Mongo (examDetail[0].faceNotFoundCount is
  // kept in sync on every increment in ImageProctoring.jsx, so it survives a resume/reload)
  // instead of always restarting at 0 - otherwise every resume silently grants a candidate a
  // fresh face-not-found violation budget, the same class of bug already fixed for quesData.
  const [faceNotFoundCount, setFaceNotFoundCount] = React.useState(() => examDetail[0].faceNotFoundCount || 0);

  const [questionChange, setQuestionChange] = React.useState(false);

  const [clearFlag, setClearFlag] = React.useState(false);

  const [checkFlag, setCheckFlag] = React.useState(false);

  const [queryResult, setQueryResult] = React.useState(false);

  const [showTimeOutModel, setTimeoutModelShow] = React.useState(false);
  const [showTimeOutModelOneMinute, setTimeoutModelOneMinuteShow] = React.useState(false);
  const [_showProcteringError, setProcteringError] = React.useState(false);

  const [showLastQuestionModal, setLastQuestionModal] = React.useState(false);

  const [showInstruction, setViewInstruction] = React.useState(true);

  const [resumeFlag, setResumeFlag] = React.useState(true);
  const [showThankyou, setThankYou] = React.useState(false);

  const [updateFlag, setUpdateFlag] = React.useState(false);

  const [answerStatus, setAnswerStatus] = React.useState([]);

  const [workFlowExamMsg, setWorkFlowExamMsg] = React.useState("");

  const [showSubmit, setShowSubmit] = React.useState(false);

  const [marksScored, setMarksScored] = React.useState(0);

  const [totalMarks, setTotalMarks] = React.useState(0);

  const [wrongAnswerCount, setWrongAnswerCount] = React.useState(0);

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [evaluation, setEvaluation] = React.useState({});

  const [webProctoringZero, setWebProcteringZero] = React.useState(false);

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [showresult, showresultActive] = React.useState(false);
  const [showModel, setModelShow] = React.useState(false);
  const [ProctoringEnd, setProctoringEnd] = React.useState(false);
  const [isAutoSpeechTest, setisAutoSpeechTest] = React.useState(false);
  // Recorded speech answers (qtypecode 23 / 31): the test needs a microphone too.
  const [isRecordedSpeechTest, setIsRecordedSpeechTest] = React.useState(false);
  const [isVideoInterviewTest, setisVideoInterviewTest] = React.useState(false);
  const [facialDataArray, setFacialDataArray] = React.useState([]);
  const [startRecordingCountdown, setStartRecordingCountdown] = React.useState(false);
  const [isRecording, setIsRecording] = React.useState(false);
  // Shared with VideoInterview so ImageProctoring can borrow live frames from
  // the active recording instead of running a second, contending camera stream.
  const recordingVideoRef = React.useRef(null);
  // The exam's one camera stream (opened by ImageProctoring). VideoInterview records from a
  // clone of its video track instead of opening the camera again - see utils/sharedCamera.js.
  const sharedCameraStreamRef = React.useRef(null);
  // True while VideoInterview's recording runs on that shared camera (false on its fallback,
  // where it opened the camera itself).
  const recordingOnSharedCameraRef = React.useRef(false);
  // Set by ImageProctoring: takes the photo at submit (finalPhotoCheck there).
  const finalPhotoRef = React.useRef(null);
  const [isVideoSent, setIsVideoSent] = React.useState(false);
  const [isVideoUploading, setIsVideoUploading] = React.useState(false);
  const [isTimeUp, setIsTimeUp] = React.useState(false);
  const [isRecordingDone, setIsRecordingDone] = React.useState(false);
  const [ImageAlertShowModal, setImageAlertShowModal] = React.useState(false);
  const [AudioAlertShowModal, setAudioAlertShowModal] = React.useState(false);
  // Speech where talking isn't expected, raised by the backend: "talking" = reminder of the rule,
  // "readingAloud" = proven reading of the question, a warning counted toward Speaker Warnings
  // (user 28 Oct 2026). Talking never aborts.
  const [SpeechAlert, setSpeechAlert] = React.useState(null);
  // Reading-aloud warnings so far: its own count against Speaker Warnings (audioproctoringcount),
  // like each image check against Proctoring Warnings. Rehydrated from examDetail[0] like AudioCount.
  const [readingAloudCount, setReadingAloudCount] = React.useState(() => examDetail[0].readingAloudCount || 0);
  // Multiple-speaker warnings so far. Rehydrated from examDetail[0] (persisted to Mongo with
  // the test progress) so a reload can't reset it - same as faceNotFoundCount below.
  const [AudioCount, setAudioCount] = React.useState(() => examDetail[0].audioCount || 0);
  const [NoFaceAlertModal, setNoFaceAlertModal] = React.useState(false);
  const [NoMatchAlertModal, setNoMatchAlertModal] = React.useState(false);
  const [MultipleFaceAlertModal, setMultipleFaceAlertModal] = React.useState(false);
  const [objectsDetected, setObjectsDetected] = React.useState([]);
  const [objectsCount, setObjectsCount] = React.useState(0);
  const [ObjectDetectedAlertModal, setObjectDetectedAlertModal] = React.useState(false);
  const [MonitoringData, setMonitoringData] = React.useState();
  const [primaryImage, setprimaryImage] = React.useState(null);
  // Whether this page load is a resume (exam already in progress): only then does the effect below
  // load the server's copy of the original reference photo, so only then does ImageProctoring wait
  // for it before registering the reference. Fixed at the first render - starting the exam sets
  // status "001" too, and waiting then meant a fresh attempt never registered its reference
  // (production from 28 Sep: ~90% of frames sent the full photo with no session key).
  const resumedOnLoadRef = React.useRef(examDetail?.[0]?.status === "001");
  const [isMongoUpdated, setisMongoUpdated] = React.useState(false);
  const [submissionFailure, setSubmissionFailure] = React.useState(false);
  const [facialSentiments, setFacialSentiments] = React.useState({});
  const [isWindowSwitched, setIsWindowSwitched] = React.useState(false);
  const [isPhotoMatchingInProgress, setIsPhotoMatchingInProgress] = React.useState(false);
  // Set by ImageProctoring while photos fail because of our server - the test timer is paused.
  const [isPhotoServerPaused, setIsPhotoServerPaused] = React.useState(false);
  // Out of full screen (desktop): questions covered and the timer paused - components/Test/FullscreenHandler.jsx.
  const [isFullscreenExited, setIsFullscreenExited] = React.useState(false);
  const [photoMismatchCount, setPhotoMismatchCount] = React.useState(() => examDetail[0].photoMismatchCount || 0);
  // Per-alert warning counts for the Proctoring Warnings limit (imageproctoringcount); each
  // alert type has its own count. Mirrored onto examDetail[0] by ImageProctoring.jsx on every
  // increment so they survive a reload/resume.
  const [multipleFaceCount, setMultipleFaceCount] = React.useState(() => examDetail[0].multipleFaceCount || 0);
  const [objectDetectedCount, setObjectDetectedCount] = React.useState(() => examDetail[0].objectDetectedCount || 0);
  const [lookingAwayCount, setLookingAwayCount] = React.useState(() => examDetail[0].lookingAwayCount || 0);

  const [responseIssue, setResponseIssue] = React.useState(false);

  // test finish time from backend
  const [utcTestStartTime, setUtcTestStartTime] = React.useState(null);
  const [utcTestFinishTime, setUtcTestFinishTime] = React.useState(null);

  let navFlag = examDetail[0].navflag;
  let showscore = examDetail[0].showscore;
  if (typeof testData === "string") {
    let decodeTestData = decodeURIComponent(atob(decodeURIComponent(testData)));
    let stringifyDecodedData = JSON.stringify(decodeTestData);
    var parseTestData = JSON.parse(stringifyDecodedData);
    testData = JSON.parse(parseTestData);
  }
  let totalAnswered = testData[0]
    ? testData.filter((v, i) => testData[i].buttonStyle === "Answered").length
    : JSON.parse(parseTestData).filter((v, i) => JSON.parse(parseTestData)[i].buttonStyle === "Answered").length;

  let totalQuestion = testData && testData.length;
  const [progress, setProgress] = React.useState(totalAnswered > 0 ? (totalAnswered / totalQuestion) * 100 : 0);

  const mandatory = examDetail[0].answermandatoryflag;

  const [showFinishModal, setFinishModal] = React.useState(false);
  // Set when a proctoring limit aborts the test (113 image, 114 speakers): the test screen is
  // replaced by the submitted message, like a time-out. The abort used to leave the test on
  // screen - candidates kept answering and their later Finish was saved over the abort
  // (staging 809769 / 809775, 26 Oct 2026).
  const [proctoringAborted, setProctoringAborted] = React.useState(false);
  const [showFinishModalDetail, setFinishModalDetail] = React.useState(false);

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [webProctoring, setWebProct] = React.useState(examDetail[0].webproctoringcount);

  const [disable, setDisable] = React.useState(false);

  // Attach the unload/reload save listeners as early as possible - previously
  // this only happened when an individual question-type component rendered
  // (VideoInterview.jsx, FillInTheBlank.jsx, etc.), leaving a window where a
  // candidate closing the tab before any answer-bearing component mounted had
  // no unload listener attached at all. onWindowReload guards its own
  // internal listener registration, so calling it here too is safe/additive.
  onWindowReload(examId, examDetail, setWindowSwitch, setTestData, windowSwitchCount, testData);

  const closeInstructionDialogue = () => {
    setViewInstruction(false);
  };

  const closeThankyou = () => {
    setThankYou(false);
    props.closeModal();
  };

  const _handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // The abort/timeout checks below are independent conditions on independent counters
  // (window-switch, face-not-found) that can both breach threshold in the same effect
  // run - e.g. a face-not-found violation landing alongside a window-switch violation.
  // Without this guard each would fire its own onSubmit() concurrently, racing on the
  // same examDetail[0].status (onSubmit only writes it after the save/submit calls
  // return, so the second call doesn't see the first one's in-progress write and isn't
  // blocked by saveToMongoFunction's "already submitted" check) - two competing
  // submit flows running underneath whatever violation modal is still on screen.
  const abortOrTimeoutTriggeredRef = React.useRef(false);

  // Copies every proctoring warning count onto examDetail[0] so they are saved with the test
  // progress and sent with the submit (written to eb.userexams by the user-backend).
  const recordProctoringCounts = () => {
    examDetail[0].faceNotFoundCount = faceNotFoundCount;
    examDetail[0].photoMismatchCount = photoMismatchCount;
    examDetail[0].multipleFaceCount = multipleFaceCount;
    examDetail[0].objectDetectedCount = objectDetectedCount;
    examDetail[0].lookingAwayCount = lookingAwayCount;
    examDetail[0].audioCount = AudioCount;
    examDetail[0].readingAloudCount = readingAloudCount;
  };

  // Keep the speaker count on examDetail[0] as it changes (it is incremented by
  // BackgroundAudioRecorder), so the next save persists it and a reload can't reset it.
  React.useEffect(() => {
    examDetail[0].audioCount = AudioCount;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AudioCount]);
  React.useEffect(() => {
    examDetail[0].readingAloudCount = readingAloudCount;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [readingAloudCount]);

  React.useEffect(() => {
    // React 18: Guard against concurrent rendering - ensure data is ready
    if (!testData || !Array.isArray(testData) || totalQuestion <= 0) {
      return;
    }

    var initLength;
    if (windowSwitchCount > 0) {
      setQuestionNo(questionNo);
    } else {
      const lastIndex = totalQuestion - 1;
      if (lastIndex >= 0 && lastIndex < testData.length && testData[lastIndex] && (testData[lastIndex].buttonStyle === "Answered" || testData[lastIndex].buttonStyle === "Not Answered")) {
        initLength =
          testData &&
          testData.filter(
            (v, i) => testData[i].buttonStyle === "Not Answered" || testData[i].buttonStyle === "Answered" || testData[i].buttonStyle === "Marked Review"
          ).length;
        setQuestionNo(initLength);
      } else {
        initLength =
          testData &&
          testData.filter(
            (v, i) => testData[i].buttonStyle === "Not Answered" || testData[i].buttonStyle === "Answered" || testData[i].buttonStyle === "Marked Review"
          ).length;
        if (initLength === 0) {
          initLength = initLength + 1;
          setQuestionNo(initLength);
        } else {
          setQuestionNo(initLength);
        }
      }
    }

    console.log("show time out model:", showTimeOutModel);
    if (!abortOrTimeoutTriggeredRef.current && showTimeOutModel) {
      console.log("inside showTimeoutModel");
      abortOrTimeoutTriggeredRef.current = true;
      if (isVideoInterviewTest && isRecordingDone) {
        onSubmit("011");
      } else {
        onSubmit("011");
      }
    } else if (!abortOrTimeoutTriggeredRef.current && (examDetail[0].webproctoringcount - windowSwitchCount < 0)) {
      abortOrTimeoutTriggeredRef.current = true;
      examDetail[0].abort_reason = "window_switch";
      onSubmit("111");
    } else if (
      !abortOrTimeoutTriggeredRef.current &&
      // Photo Action = Stop: any image alert type crossing the shared Proctoring Warnings
      // limit (imageproctoringcount) aborts with 113. Photo mismatch and looking away are warned
      // and counted but do not abort yet (false mismatches are still too common - see
      // ImageProctoring.jsx; looking away was wrong on about 1 in 5 warnings in the 23 Oct 2026
      // staging round - user 26 Oct: warn, don't count towards the abort for now).
      (MonitoringData && MonitoringData.result.photo_action === "S" &&
        (isFaceNotFoundBudgetExceeded(examDetail, faceNotFoundCount) ||
          isWarningLimitExceeded(examDetail[0].imageproctoringcount, multipleFaceCount) ||
          isWarningLimitExceeded(examDetail[0].imageproctoringcount, objectDetectedCount) ||
          ProctoringEnd === true))
    ) {
      abortOrTimeoutTriggeredRef.current = true;
      if (isFaceNotFoundBudgetExceeded(examDetail, faceNotFoundCount)) {
        examDetail[0].abort_reason = "face_not_found";
      } else if (isWarningLimitExceeded(examDetail[0].imageproctoringcount, multipleFaceCount)) {
        examDetail[0].abort_reason = "multiple_faces";
      } else if (isWarningLimitExceeded(examDetail[0].imageproctoringcount, objectDetectedCount)) {
        examDetail[0].abort_reason = "object_detected";
      } else {
        examDetail[0].abort_reason = "photo_mismatch";
      }
      recordProctoringCounts();
      setProctoringAborted(true);
      onSubmit("113");
    } else if (
      !abortOrTimeoutTriggeredRef.current &&
      // Speaker Proctoring Action = Stop: multiple-speaker or reading-aloud warnings (each its own
      // count) crossing Speaker Warnings (audioproctoringcount) abort with 114.
      MonitoringData && MonitoringData.result.speaker_dialect === true && MonitoringData.result.audio_action === "S" &&
      (isWarningLimitExceeded(examDetail[0].audioproctoringcount, AudioCount) ||
        isWarningLimitExceeded(examDetail[0].audioproctoringcount, readingAloudCount))
    ) {
      abortOrTimeoutTriggeredRef.current = true;
      examDetail[0].abort_reason = isWarningLimitExceeded(examDetail[0].audioproctoringcount, AudioCount)
        ? "multiple_speakers"
        : "reading_aloud";
      recordProctoringCounts();
      setProctoringAborted(true);
      onSubmit("114");
    }
    // showTimeOutModelOneMinute deliberately excluded - it's never referenced anywhere in
    // this effect's body, so including it only re-runs the questionNo recompute above (and
    // re-checks every abort condition) every time the 1-minute warning modal opens or closes,
    // for no functional reason. A candidate reported their answers appearing wiped and being
    // moved back to question 1 right after clicking OK on that modal - this spurious re-run
    // is the direct cause of that visible jump (the recompute itself is idempotent against
    // unchanged testData in the normal case, but firing it at all here was never intentional).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTimeOutModel, windowSwitchCount, ProctoringEnd, faceNotFoundCount, multipleFaceCount, objectDetectedCount, lookingAwayCount, AudioCount, readingAloudCount]);

  // "Last active" stamp while the test page is open, so a refresh can be told apart from a
  // resume (utils/proctoringSession.js - no new photo on a refresh, on phones and desktops).
  React.useEffect(() => {
    if (!examId) return undefined;
    markTestActive(examId);
    const stampId = setInterval(() => markTestActive(examId), ACTIVE_STAMP_MS);
    const onLeave = () => markTestActive(examId);
    window.addEventListener("pagehide", onLeave);
    window.addEventListener("beforeunload", onLeave);
    return () => {
      clearInterval(stampId);
      window.removeEventListener("pagehide", onLeave);
      window.removeEventListener("beforeunload", onLeave);
    };
  }, [examId]);

  // Periodic heartbeat autosave. The only saves during active answering today are
  // event-driven (tab-switch, refresh, a proctoring violation) - a candidate whose tab
  // dies abruptly (crash, dropped connection, OS backgrounding/killing the tab) between
  // those events can lose every answer given since the last one, with nothing in Mongo
  // beyond the start-of-test snapshot. This bounds that loss window to ~30s instead of
  // potentially the whole test. heartbeatSaveFunction is a no-op once the test has
  // reached a terminal status, so a slightly-late tick after submission is harmless.
  const isHeartbeatSavingRef = React.useRef(false);
  React.useEffect(() => {
    if (examDetail[0].status !== "001") {
      return undefined;
    }
    const HEARTBEAT_INTERVAL_MS = 30000;
    const heartbeatId = setInterval(() => {
      if (isHeartbeatSavingRef.current) {
        return;
      }
      isHeartbeatSavingRef.current = true;
      heartbeatSaveFunction(examId, examDetail, testData).finally(() => {
        isHeartbeatSavingRef.current = false;
      });
    }, HEARTBEAT_INTERVAL_MS);
    return () => clearInterval(heartbeatId);
  }, [examId, examDetail, testData]);

  React.useEffect(() => {
    for (let i in testData) {
      if (testData[i].qtypecode === "28") {
        setisAutoSpeechTest(true);
      }
      if (testData[i].qtypecode === "27") {
        setisVideoInterviewTest(true);
      }
      if (testData[i].qtypecode === "23" || testData[i].qtypecode === "31") {
        setIsRecordedSpeechTest(true);
      }
    }
    axios
      .post("/test/getMonitoringData", {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        userexamid: examDetail[0].id,
        instanceid: examDetail[0].instanceid,
      })
      .then((resp) => {
        if (resp.data.result.photo_matching === null) {
          resp.data.result.photo_matching = false;
        }
        if (resp.data.result.speaker_dialect === null) {
          resp.data.result.speaker_dialect = false;
        }
        if (resp.data.result.photo_action === null) {
          resp.data.result.photo_action = "C";
        }
        if (resp.data.result.audio_action === null) {
          resp.data.result.audio_action = "C";
        }
        if (resp.data.result.photo_timer === null) {
          resp.data.result.photo_timer = 120;
        }
        // Like its siblings: null matched neither the === true nor the === false branch in
        // ImageProctoring.jsx, so a detected object was silently left unhandled for the exam.
        if (resp.data.result.object_detection === null) {
          resp.data.result.object_detection = false;
        }
        // Multiple faces, photo matching, phone & headphones and looking away run only on the Live
        // Check Timer: no timer set = none of them run (user 28 Oct 2026). Face not visible still
        // runs on the Photo Click Timer whenever Image Proctoring is on.
        if (!(Number(resp.data.result.live_check_timer) > 0)) {
          resp.data.result.multiple_faces = false;
          resp.data.result.photo_matching = false;
          resp.data.result.object_detection = false;
          resp.data.result.looking_away = false;
        }
        // Reconcile admin-configured violation thresholds against whatever examDetail is
        // currently held, regardless of whether it came from the fresh /userTest prop, a
        // resumed localStorage snapshot (Instruction.jsx), or the raw page-reload localStorage
        // fallback above (which has no fresh prop to fall back on at all). This effect runs
        // once on every Test.jsx mount unconditionally, so it's the one place that can catch
        // ALL of those paths. imageproctoringcount/webproctoringcount always come from the DB
        // (never null); facenotfoundcount is deliberately left as-is (including null, meaning
        // "not configured") - never coerced to a number here.
        //
        // webproctoringcount is a DRAINING budget (saveToMongoFunction.js decrements it by
        // windowSwitchCount on every save and persists the remainder to Mongo) - on a resume,
        // examDetail[0].webproctoringcount already holds that correctly-drained value. Only
        // ever take the fresh DB value if it's LOWER (an admin genuinely tightened the limit
        // mid-exam) or if there's no existing value yet (a real first start) - never let this
        // reconciliation hand a resuming candidate a freshly-restored full budget, which is
        // exactly how repeated resume used to reset the window-switch abort threshold every time.
        if (resp.data.result.imageproctoringcount != null) {
          examDetail[0].imageproctoringcount =
            examDetail[0].imageproctoringcount != null
              ? Math.min(examDetail[0].imageproctoringcount, resp.data.result.imageproctoringcount)
              : resp.data.result.imageproctoringcount;
        }
        if (resp.data.result.webproctoringcount != null) {
          examDetail[0].webproctoringcount =
            examDetail[0].webproctoringcount != null
              ? Math.min(examDetail[0].webproctoringcount, resp.data.result.webproctoringcount)
              : resp.data.result.webproctoringcount;
        }
        if (resp.data.result.audioproctoringcount != null) {
          examDetail[0].audioproctoringcount =
            examDetail[0].audioproctoringcount != null
              ? Math.min(examDetail[0].audioproctoringcount, resp.data.result.audioproctoringcount)
              : resp.data.result.audioproctoringcount;
        }
        examDetail[0].facenotfoundcount = resp.data.result.facenotfoundcount;
        if (resp.data.result.monitoring === true && examDetail[0].status === "001") {
          axios
            .post("/test/sendPrimaryImage", {
              headers: {
                "Access-Control-Allow-Origin": "*",
              },
              userid: examDetail[0].userid,
              userexamid: examDetail[0].id,
            })
            .then((resp) => {
              if (resp.data?.primaryImage?.imagepath) {
                setprimaryImage(resp.data.primaryImage.imagepath);
              }
            });
        }
        setMonitoringData(resp.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addNewQuestion = () => {
    //Add only if adaptive
    //setLastQuestionModal(false)
    if (testData && testData[testData.length - 1].buttonStyle !== "Not Visited") {
      let elem = testData;
      let totalmarksAttempt = elem.reduce((a, b) => a + b["qmarks"], 0);

      if (examDetail[0].totalmarkstoattempt - totalmarksAttempt >= examDetail[1]["3"][0].qmarks) {
        if (elem[elem.length - 1].answerStatus) {
          if (elem[elem.length - 1].qdifficultylevelid === "3" || elem[elem.length - 1].qdifficultylevelid === "2") {
            elem.push(examDetail[1]["3"][Math.floor(Math.random() * examDetail[1]["3"].length)]);
            elem[elem.length - 1].index = examDetail[1]["3"].findIndex((x) => x.qid === elem[elem.length - 1].qid);
            examDetail[1]["3"].splice(elem[elem.length - 1].index, 1);
          } else if (elem[elem.length - 1].qdifficultylevelid === "1") {
            elem.push(examDetail[1]["2"][Math.floor(Math.random() * examDetail[1]["2"].length)]);
            elem[elem.length - 1].index = examDetail[1]["2"].findIndex((x) => x.qid === elem[elem.length - 1].qid);
            examDetail[1]["2"].splice(elem[elem.length - 1].index, 1);
          }
        } else {
          if (elem[elem.length - 1].qdifficultylevelid === "3") {
            elem.push(examDetail[1]["2"][Math.floor(Math.random() * examDetail[1]["2"].length)]);
            elem[elem.length - 1].index = examDetail[1]["2"].findIndex((x) => x.qid === elem[elem.length - 1].qid);
            examDetail[1]["2"].splice(elem[elem.length - 1].index, 1);
          } else if (elem[elem.length - 1].qdifficultylevelid === "2" || elem[elem.length - 1].qdifficultylevelid === "1") {
            elem.push(examDetail[1]["1"][Math.floor(Math.random() * examDetail[1]["1"].length)]);
            elem[elem.length - 1].index = examDetail[1]["1"].findIndex((x) => x.qid === elem[elem.length - 1].qid);
            examDetail[1]["1"].splice(elem[elem.length - 1].index, 1);
          }
        }
      } else if (examDetail[0].totalmarkstoattempt - totalmarksAttempt >= examDetail[1]["2"][0].qmarks) {
        if (elem[elem.length - 1].answerStatus) {
          elem.push(examDetail[1]["2"][Math.floor(Math.random() * examDetail[1]["2"].length)]);
          elem[elem.length - 1].index = examDetail[1]["2"].findIndex((x) => x.qid === elem[elem.length - 1].qid);
          examDetail[1]["2"].splice(elem[elem.length - 1].index, 1);
        } else {
          if (elem[elem.length - 1].qdifficultylevelid === "3") {
            elem.push(examDetail[1]["2"][Math.floor(Math.random() * examDetail[1]["2"].length)]);
            elem[elem.length - 1].index = examDetail[1]["2"].findIndex((x) => x.qid === elem[elem.length - 1].qid);
            examDetail[1]["2"].splice(elem[elem.length - 1].index, 1);
          } else if (elem[elem.length - 1].qdifficultylevelid === "2" || elem[elem.length - 1].qdifficultylevelid === "1") {
            elem.push(examDetail[1]["1"][Math.floor(Math.random() * examDetail[1]["1"].length)]);
            elem[elem.length - 1].index = examDetail[1]["1"].findIndex((x) => x.qid === elem[elem.length - 1].qid);
            examDetail[1]["1"].splice(elem[elem.length - 1].index, 1);
          }
        }
      } else if (examDetail[0].totalmarkstoattempt - totalmarksAttempt >= examDetail[1]["1"][0].qmarks) {
        elem.push(examDetail[1]["1"][Math.floor(Math.random() * examDetail[1]["1"].length)]);
        elem[elem.length - 1].index = examDetail[1]["1"].findIndex((x) => x.qid === elem[elem.length - 1].qid);
        examDetail[1]["1"].splice(elem[elem.length - 1].index, 1);
      } else {
        setLastQuestionModal(true);
        setShowSubmit(true);
      }
    }
  };

  if (examDetail[0].status === "000") {
    if (examDetail[0].webproctoringcount === 0) {
      examDetail[0].defaultZeroProctorCheck = true;
    }
  }

  const onSubmit = async (status) => {
    console.log("going to submit with status", status);

    setUpdateFlag(true);
    let userExamId = examDetail[0].id;

    // check whether we have a data of the user or not.
    let notVisitedCount = 0;
    for (let i in testData) {
      if (testData[i].buttonStyle !== "Answered") {
        notVisitedCount += 1;
      }
    }

    console.log("check 1");

    // Proctoring aborts (111 window switch, 113 camera, 114 speakers - all "11x") must always be
    // submitted: this "no answers yet" guard used to swallow them, so a video test (first answer
    // not saved yet) hit the face-not-found limit and stayed stuck on the response-issue screen
    // until a refresh aborted it (staging 809413, 27 Sep 2026).
    const isProctoringAbort = /^11\d$/.test(String(status));

    if (testData.length === notVisitedCount && !isProctoringAbort) {
      let remainingTime = window.localStorage.getItem("remainingTime");
      console.log("remaining time:", remainingTime);

      const totalTestTime = examDetail[0].total_test_time;
      console.log("total test time:", totalTestTime);

      if (!remainingTime) {
        setResponseIssue(true);
        examDetail[0].status = "998"; // new status to neglect the result processing
        return;
      } else if (Number(remainingTime) === Number(totalTestTime)) {
        setResponseIssue(true);
        examDetail[0].status = "998"; // new status to neglect the result processing
        return;
      }
    }

    console.log("check 2");

    try {
      setQueryResult(true);

      // Photo at submit (exam-end gap): one last photo when the candidate submits. Not on a
      // proctoring abort, and not when the time runs out: the test screen (and the camera) is
      // already replaced by the time-out message before this runs, so the photo could never be
      // taken and every timed-out test recorded "not_sent" (production 25 of 25, 29-30 Sep).
      // Regular photos run until the last interval there. Its outcome is saved with the test.
      if (status === "010" && examDetail[0].monitoringflag && finalPhotoRef.current) {
        const finalPhoto = await finalPhotoRef.current();
        if (finalPhoto) examDetail[0].finalPhoto = finalPhoto;
      }

      console.log("check 3");

      // First try to save data to MongoDB
      let mongoSaveResponse = await onFinishSaveToMongoFunction(
        examId,
        examDetail,
        setWindowSwitch,
        setTestData,
        windowSwitchCount,
        faceNotFoundCount,
        testData,
        status
      );

      console.log("saved in mongodb", mongoSaveResponse);

      examDetail[0].status = status;

      // encode data
      let stringifyExamDetail = JSON.stringify(examDetail);
      let encodedExamDetail = encodeURIComponent(btoa(encodeURIComponent(stringifyExamDetail)));
      let stringifyQuesData = JSON.stringify(testData);
      let encodedQuesData = encodeURIComponent(btoa(encodeURIComponent(stringifyQuesData)));

      // Best-effort persistence of the final submission payload once every
      // network attempt below is exhausted - IndexedDB (500MB+, async) instead
      // of raw localStorage (~5-10MB quota, can throw on a large exam payload).
      // Falls back to localStorage only if IndexedDB itself is unavailable.
      const persistPendingSubmission = async () => {
        const submissionData = { userExamId, examDetail: encodedExamDetail, questionsData: encodedQuesData };
        const savedToIndexedDB = await savePendingSubmission(userExamId, submissionData);
        if (!savedToIndexedDB) {
          try {
            localStorage.setItem(`test-submit-${userExamId}`, JSON.stringify(submissionData));
          } catch (storageError) {
            console.log("Failed to store data in localStorage", storageError);
          }
        }
        setSubmissionFailure(true);
      };

      if (mongoSaveResponse === true) {
        // Data saved in MongoDB, now try to submit the test
        try {
          const submitResponse = await postWithRetry(
            () =>
              axios.post(
                `/result/submittest/${userExamId}`,
                {
                  examDetail: encodedExamDetail,
                  questionsData: encodedQuesData,
                  submitType: "STANDARD",
                },
                {
                  headers: {
                    "Access-Control-Allow-Origin": "*",
                  },
                }
              ),
            { label: "submittest" }
          );

          if (submitResponse.status === 200) {
            if (submitResponse.data.nextAction && submitResponse.data.nextAction === "retest") {
              setResponseIssue(true);
            }
          }
        } catch (error) {
          console.log("Submit test error, trying fallback", error);
          // If error occurs, try /fallbacksubmit
          try {
            const fallbackResponse = await postWithRetry(
              () =>
                axios.post(`/result/fallbacksubmit/${userExamId}`, {
                  examDetail: encodedExamDetail,
                  questionsData: encodedQuesData,
                  submitType: "FALLBACK_ON_CATCH",
                }),
              { label: "fallbacksubmit" }
            );
            console.log("fallback Response 1", fallbackResponse);
          } catch (fallbackError) {
            console.log("Fallback submission failed, persisting for later retry", fallbackError);
            await persistPendingSubmission();
          }
        }
      } else {
        // If MongoDB save fails, send data to /independent-resultprocess
        try {
          const testProcessResponse = await postWithRetry(
            () =>
              axiosInstance.post(
                resultBaseURL + "/independent-resultprocess",
                {
                  examDetail: encodedExamDetail,
                  questionsData: encodedQuesData,
                  submitType: "MONGODB_SKIPPED",
                },
                {
                  headers: {
                    "Access-Control-Allow-Origin": "*",
                  },
                }
              ),
            { label: "independent-resultprocess (mongo-skipped)" }
          );

          console.log("independent test response 1:", testProcessResponse);

          // Best-effort Mongo backfill: we reached this branch because the earlier
          // saveToMongoFunction exhausted its retries. Try once more in the background
          // so the usertestdatas doc eventually exists for downstream analytics. The
          // /test/answeredQuestions endpoint upserts, so this is safe to replay.
          axios
            .post("/test/answeredQuestions", {
              headers: { "Access-Control-Allow-Origin": "*" },
              examDetail: encodedExamDetail,
              id: userExamId,
              quesData: encodedQuesData,
            })
            .then(() => console.log("✅ Mongo backfill after independent-resultprocess succeeded"))
            .catch((backfillErr) => console.log("Mongo backfill after independent-resultprocess failed:", backfillErr?.message));
        } catch (independentError) {
          console.log("Independent result process failed, persisting for later retry", independentError);
          await persistPendingSubmission();
        }
      }
    } catch (error) {
      console.log("Mongo save error", error);
      // If saving to MongoDB fails, call /independent-resultprocess

      examDetail[0].status = status;

      // encode data
      let stringifyExamDetail = JSON.stringify(examDetail);
      let encodedExamDetail = encodeURIComponent(btoa(encodeURIComponent(stringifyExamDetail)));
      let stringifyQuesData = JSON.stringify(testData);
      let encodedQuesData = encodeURIComponent(btoa(encodeURIComponent(stringifyQuesData)));

      try {
        // Same host/path as the mongo-skipped branch above. Previously this
        // called axios.post("/result/independent-resultprocess", ...) which
        // resolves against the MAIN api host - that route only exists on the
        // separate result-processing host (finalResult.js), so this call
        // 404'd every single time it was reached, skipping straight to the
        // localStorage dead end regardless of retry.
        const testProcessResponse = await postWithRetry(
          () =>
            axiosInstance.post(
              resultBaseURL + "/independent-resultprocess",
              {
                examDetail: encodedExamDetail,
                questionsData: encodedQuesData,
                submitType: "MONGODB_SKIPPED_CATCH",
              },
              {
                headers: {
                  "Access-Control-Allow-Origin": "*",
                },
              }
            ),
          { label: "independent-resultprocess (outer catch)" }
        );
        console.log("independent test response 2:", testProcessResponse);
      } catch (independentError) {
        console.log("Independent result process failed again, persisting for later retry", independentError);

        // If everything fails, store data for later retry (IndexedDB, falling
        // back to localStorage only if IndexedDB itself is unavailable)
        try {
          const submissionData = { userExamId, examDetail: encodedExamDetail, questionsData: encodedQuesData };
          const savedToIndexedDB = await savePendingSubmission(userExamId, submissionData);
          if (!savedToIndexedDB) {
            localStorage.setItem(`test-submit-${userExamId}`, JSON.stringify(submissionData));
          }
          setSubmissionFailure(true);
        } catch (storageError) {
          console.log("Failed to store data for later retry", storageError);
        }
      }
    } finally {
      // Completed the submission process
      setQueryResult(false);
    }
  };

  React.useEffect(() => {
    const handleKeyUp = function (e) {
      const mainBody = document.getElementById("main-body");
      const mainBodyTwo = document.getElementById("main-body-two");
      if (e.metaKey || e.shiftKey) {
        if (mainBody) {
          mainBody.style.filter = "";
        } else if (mainBodyTwo) {
          mainBodyTwo.style.filter = "";
        }
      }
      if (e.keyCode === 91 || e.keyCode === 92 || e.keyCode === 44) {
        if (mainBody) {
          mainBody.style.filter = "";
        } else if (mainBodyTwo) {
          mainBodyTwo.style.filter = "";
        }
      }
      if (e.key === "Control") {
        if (mainBody) {
          mainBody.style.filter = "";
        } else if (mainBodyTwo) {
          mainBodyTwo.style.filter = "";
        }
      }
    };

    const handleClick = function (_e) {
      const mainBody = document.getElementById("main-body");
      const mainBodyTwo = document.getElementById("main-body-two");
      if (mainBody) {
        mainBody.style.filter = "";
      } else if (mainBodyTwo) {
        mainBodyTwo.style.filter = "";
      }
    };

    const handleKeyDown = function (e) {
      const mainBody = document.getElementById("main-body");
      const mainBodyTwo = document.getElementById("main-body-two");
      if (e.metaKey && e.shiftKey) {
        if (mainBody) {
          mainBody.style.filter = "blur(5px)";
        } else if (mainBodyTwo) {
          mainBodyTwo.style.filter = "blur(5px)";
        }
      }
      if (e.metaKey && e.keyCode === 80) {
        return false;
      }
      if ((e.keyCode === 91 || e.keyCode === 92) && e.keyCode === 44) {
        if (mainBody) {
          mainBody.style.filter = "blur(5px)";
        } else if (mainBodyTwo) {
          mainBodyTwo.style.filter = "blur(5px)";
        }
      }
      if (e.key === "Control") {
        if (mainBody) {
          mainBody.style.filter = "blur(5px)";
        } else if (mainBodyTwo) {
          mainBodyTwo.style.filter = "blur(5px)";
        }
      }
      if (e.metaKey && e.shiftKey && e.key === "4") {
        return false;
      }
    };

    window.addEventListener("keyup", handleKeyUp);
    window.addEventListener("click", handleClick);
    window.addEventListener("keydown", handleKeyDown);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keyup", handleKeyUp);
      window.removeEventListener("click", handleClick);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // React 18: Guard against concurrent rendering - prevent render if data not ready
  if (!examDetail || !Array.isArray(examDetail) || examDetail.length === 0) {
    return null;
  }

  return (
    <>
      {responseIssue ? (
        <>
          <ResponseIssueModal onSubmit={onSubmit} examId={examId} />
        </>
      ) : showTimeOutModel || proctoringAborted ? (
        <TimeOutModal
          updateFlag={updateFlag}
          showTimeOutModel={true}
          proctoringAborted={proctoringAborted && !showTimeOutModel}
          setTimeoutModelShow={setTimeoutModelShow}
          setFinishModal={setFinishModal}
          onSubmit={onSubmit}
          result={evaluation}
          showResult={showresult}
          showscore={examDetail[0].showscoreflag}
          examId={examId}
          examDetail={examDetail}
          setWindowSwitch={setWindowSwitch}
          setTestData={setTestData}
          windowSwitchCount={windowSwitchCount}
          testData={testData}
        />
      ) : showInstruction ? (
        <>
          <Dialog
            disableEscapeKeyDown
            PaperProps={{ style: { background: "#e5e5e9" } }}
            fullScreen
            open={showInstruction}
            onClose={closeInstructionDialogue}
            slots={{ transition: Transition }}
          >
            <InstructionPage
              examDetail={examDetail}
              setViewInstruction={setViewInstruction}
              themeType={props.themeType}
              changeTheme={props.changeTheme}
              testData={testData}
              setTestData={setTestData}
              MonitoringData={MonitoringData}
              isAutoSpeechTest={isAutoSpeechTest}
              isVideoInterviewTest={isVideoInterviewTest}
              isRecordedSpeechTest={isRecordedSpeechTest}
              utcTestStartTime={utcTestStartTime}
              setUtcTestStartTime={setUtcTestStartTime}
              utcTestFinishTime={utcTestFinishTime}
              setUtcTestFinishTime={setUtcTestFinishTime}
            />
          </Dialog>
        </>
      ) : showThankyou ? (
        <ThankyouPage
          examDetail={examDetail}
          closeThankyou={closeThankyou}
          themeType={props.themeType}
          changeTheme={props.changeTheme}
          evaluation={evaluation}
        />
      ) : showFinishModal ? (
        showThankyou ? (
          <ThankyouPage
            examDetail={examDetail}
            closeThankyou={closeThankyou}
            themeType={props.themeType}
            changeTheme={props.changeTheme}
            evaluation={evaluation}
          />
        ) : (
          <FinishModal
            workFlowExamMsg={workFlowExamMsg}
            setWorkFlowExamMsg={setWorkFlowExamMsg}
            workflowContext={workflowContext}
            queryResult={queryResult}
            showFinishModal={showFinishModal}
            onSubmit={onSubmit}
            result={evaluation}
            showResult={showresult}
            showscore={examDetail[0].showscoreflag}
            setResumeFlag={setResumeFlag}
            examId={examId}
            examDetail={examDetail}
            setWindowSwitch={setWindowSwitch}
            setTestData={setTestData}
            windowSwitchCount={windowSwitchCount}
            testData={testData}
            submissionFailure={submissionFailure}
          />
        )
      ) : (
        // workFlowExamMsg !== '' ? < WorkFlowMessageModal workFlowExamMsg = {workFlowExamMsg} setWorkFlowExamMsg = {setWorkFlowExamMsg}/> :
        // The grey page and the white question card fill the screen (full screen leaves a tall empty
        // area under a short question otherwise); the card ends 25px above the bottom.
        <div id="main-body" style={{ background: "#E5E6E9", minHeight: "100vh" }}>
          {(testData[questionNo - 1].qtypecode !== "23" ||
            testData[questionNo - 1].qtypecode !== "25" ||
            testData[questionNo - 1].qtypecode !== "27" ||
            testData[questionNo - 1].qtypecode !== "26" ||
            testData[questionNo - 1].qtypecode !== "19" ||
            testData[questionNo - 1].qtypecode !== "29") &&
            examDetail[0].defaultZeroProctorCheck !== true ? (
            webProctoring > 0 || examDetail[0].webproctoringzero === true ? (
              <WindowFocusHandler
                updateFlag={updateFlag}
                showModel={showModel}
                setModelShow={setModelShow}
                setWindowSwitch={setWindowSwitch}
                windowSwitchCount={windowSwitchCount}
                faceNotFoundCount={faceNotFoundCount}
                themeType={props.themeType}
                examId={examId}
                examDetail={examDetail}
                testData={testData}
                setTestData={setTestData}
                closeModal={props.closeModal}
                onSubmit={onSubmit}
                result={evaluation}
                showResult={showresult}
                setWebProcteringZero={setWebProcteringZero}
                webProctoringZero={webProctoringZero}
                webProctoring={webProctoring}
                showscore={examDetail[0].showscoreflag}
                setIsWindowSwitched={setIsWindowSwitched}
              />
            ) : (
              ""
            )
          ) : (
            ""
          )}

          <CopyPasteHandler examDetail={examDetail} />
          <FullscreenHandler examDetail={examDetail} setIsFullscreenExited={setIsFullscreenExited} />

          {showFinishModalDetail ? (
            <FinishModalDetail
              examDetail={examDetail}
              testData={testData}
              setFinishModal={setFinishModal}
              setFinishModalDetail={setFinishModalDetail}
              showFinishModalDetail={showFinishModalDetail}
              onSubmit={onSubmit}
            />
          ) : (
            ""
          )}
          {showTimeOutModelOneMinute ? (
            <TimeOutModalOneMinute
              showTimeOutModelOneMinute={showTimeOutModelOneMinute}
              setTimeoutModelOneMinuteShow={setTimeoutModelOneMinuteShow}
              onSubmit={onSubmit}
              examDetail={examDetail}
            />
          ) : showLastQuestionModal ? (
            <LastQuestionModal showLastQuestionModal={showLastQuestionModal} setLastQuestionModal={setLastQuestionModal} examDetail={examDetail} />
          ) : (
            ""
          )}
          {/* {
                           showProcteringError ?
                           <ProctoringError showProcteringError={showProcteringError} setProcteringError={setProcteringError}/>
                           :
                           ""

                         } */}
          <div className="container-fluid main-wrap">
            <TestAppBar
              showModel={showModel}
              ImageAlertShowModal={ImageAlertShowModal}
              AudioAlertShowModal={AudioAlertShowModal}
              NoFaceAlertModal={NoFaceAlertModal}
              facialSentiments={facialSentiments}
              NoMatchAlertModal={NoMatchAlertModal}
              MultipleFaceAlertModal={MultipleFaceAlertModal}
              showFinishModalDetail={showFinishModalDetail}
              value={value}
              onSubmit={onSubmit}
              changeTheme={props.changeTheme}
              themeType={props.themeType}
              setQuestionNo={setQuestionNo}
              setViewInstruction={setViewInstruction}
              examDetail={examDetail}
              navFlag={navFlag}
              setQuestionChange={setQuestionChange}
              testData={testData}
              questionNo={questionNo}
              setTimeoutModelShow={setTimeoutModelShow}
              setTimeoutModelOneMinuteShow={setTimeoutModelOneMinuteShow}
              isVideoUploading={isVideoUploading}
              isTimeUp={isTimeUp}
              setIsTimeUp={setIsTimeUp}
              isRecordingDone={isRecordingDone}
              setIsRecordingDone={setIsRecordingDone}
              isVideoInterviewTest={isVideoInterviewTest}
              utcTestStartTime={utcTestStartTime}
              setUtcTestStartTime={setUtcTestStartTime}
              utcTestFinishTime={utcTestFinishTime}
              setUtcTestFinishTime={setUtcTestFinishTime}
              isWindowSwitched={isWindowSwitched}
              isPhotoMatchingInProgress={isPhotoMatchingInProgress}
              isPhotoServerPaused={isPhotoServerPaused}
              isFullscreenExited={isFullscreenExited}
            />

            <Grid item xs={1} />
            {/* {
                        examDetail[0].livemonitoringflag ?<LiveProct examDetail={examDetail}/> : <></>
                      } */}
            {examDetail[0].monitoringflag ? (
              <ImageProct
                finalPhotoRef={finalPhotoRef}
                setProcteringError={setProcteringError}
                examDetail={examDetail}
                setImageAlertShowModal={setImageAlertShowModal}
                ImageAlertShowModal={ImageAlertShowModal}
                ProctoringEnd={ProctoringEnd}
                setProctoringEnd={setProctoringEnd}
                setAudioAlertShowModal={setAudioAlertShowModal}
                AudioAlertShowModal={AudioAlertShowModal}
                facialDataArray={facialDataArray}
                setFacialDataArray={setFacialDataArray}
                NoFaceAlertModal={NoFaceAlertModal}
                facialSentiments={facialSentiments}
                setNoFaceAlertModal={setNoFaceAlertModal}
                setFacialSentiments={setFacialSentiments}
                NoMatchAlertModal={NoMatchAlertModal}
                setNoMatchAlertModal={setNoMatchAlertModal}
                MultipleFaceAlertModal={MultipleFaceAlertModal}
                setMultipleFaceAlertModal={setMultipleFaceAlertModal}
                ObjectDetectedAlertModal={ObjectDetectedAlertModal}
                setObjectDetectedAlertModal={setObjectDetectedAlertModal}
                objectsDetected={objectsDetected}
                setObjectsDetected={setObjectsDetected}
                setObjectsCount={setObjectsCount}
                objectsCount={objectsCount}
                MonitoringData={MonitoringData}
                primaryImage={primaryImage}
                setprimaryImage={setprimaryImage}
                referenceFromServer={resumedOnLoadRef.current}
                examId={examId}
                setWindowSwitch={setWindowSwitch}
                setTestData={setTestData}
                windowSwitchCount={windowSwitchCount}
                setFaceNotFoundCount={setFaceNotFoundCount}
                faceNotFoundCount={faceNotFoundCount}
                testData={testData}
                isMongoUpdated={isMongoUpdated}
                setisMongoUpdated={setisMongoUpdated}
                isVideoUploading={isVideoUploading}
                questionNo={questionNo}
                isRecording={isRecording}
                recordingVideoRef={recordingVideoRef}
                sharedCameraStreamRef={sharedCameraStreamRef}
                recordingOnSharedCameraRef={recordingOnSharedCameraRef}
                setIsPhotoMatchingInProgress={setIsPhotoMatchingInProgress}
                setIsPhotoServerPaused={setIsPhotoServerPaused}
                photoMismatchCount={photoMismatchCount}
                setPhotoMismatchCount={setPhotoMismatchCount}
                multipleFaceCount={multipleFaceCount}
                setMultipleFaceCount={setMultipleFaceCount}
                objectDetectedCount={objectDetectedCount}
                setObjectDetectedCount={setObjectDetectedCount}
                setLookingAwayCount={setLookingAwayCount}
              />
            ) : (
              <></>
            )}
            {MonitoringData?.result?.speaker_dialect === true && (
              <>
                <BackgroundAudioRecorder
                  examDetail={examDetail}
                  questionNo={questionNo}
                  MonitoringData={MonitoringData}
                  setAudioCount={setAudioCount}
                  setReadingAloudCount={setReadingAloudCount}
                  setAudioAlertShowModal={setAudioAlertShowModal}
                  alertVisible={AudioAlertShowModal}
                  // No audio checks on speaking/listening questions; on a video-interview answer being
                  // recorded only the second-voice check runs (see audioCheckMode).
                  audioCheckMode={audioCheckMode(Array.isArray(testData) ? testData[questionNo - 1] : null, isRecording)}
                  setSpeechAlert={setSpeechAlert}
                  speechAlert={SpeechAlert}
                  questionId={Array.isArray(testData) ? testData[questionNo - 1]?.qid : null}
                />
                {/* Steps aside while a speaker or window-switch warning is open: those count toward
                    an abort, and the window-switch one sits lower (MUI default z-index). */}
                <SpeechAlertModal
                  kind={AudioAlertShowModal || showModel ? null : SpeechAlert}
                  onConfirm={() => setSpeechAlert(null)}
                  audioAction={MonitoringData?.result?.audio_action || "C"}
                  readingAloudCount={readingAloudCount}
                  limit={examDetail[0].audioproctoringcount}
                />
                <AudioAlertModal
                  open={AudioAlertShowModal}
                  audioAction={MonitoringData?.result?.audio_action || "C"}
                  count={AudioCount}
                  limit={examDetail[0].audioproctoringcount}
                  // Abort (114) is decided by the proctoring-limit effect above as soon as the
                  // count crosses Speaker Warnings; OK only closes the warning.
                  onConfirm={() => setAudioAlertShowModal(false)}
                />
              </>
            )}
            <div className="row">
              <div className="container  qa-wrap" style={{ top: "25px", marginTop: "60px", minHeight: "calc(100vh - 110px)" }}>
                <div className="qa-overlay" id="main-layout"></div>

                <div className="col-md-12 question-box" id="layout-2">
                  {/* <ProgressBar bgcolor="#8c59b3" completed={progress}/> */}
                  {/* {console.log('testData[questionNo - 1]',testData[questionNo - 1])} */}
                  {testData[questionNo - 1].qtypecode === "12" || testData[questionNo - 1].qtypecode === "26" ? (
                    <FillInTheBlank
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      marksScored={marksScored}
                      setMarksScored={setMarksScored}
                      totalMarks={totalMarks}
                      setTotalMarks={setTotalMarks}
                      wrongAnswerCount={wrongAnswerCount}
                      setWrongAnswerCount={setWrongAnswerCount}
                      disable={disable}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      resumeFlag={resumeFlag}
                      setResumeFlag={setResumeFlag}
                      windowSwitchCount={windowSwitchCount}
                      setWindowSwitch={setWindowSwitch}
                      setWebProcteringZero={setWebProcteringZero}
                    />
                  ) : testData[questionNo - 1].qtypecode === "17" ? (
                    <EnterMarksPattern
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      marksScored={marksScored}
                      setMarksScored={setMarksScored}
                      totalMarks={totalMarks}
                      setTotalMarks={setTotalMarks}
                      wrongAnswerCount={wrongAnswerCount}
                      setWrongAnswerCount={setWrongAnswerCount}
                      disable={disable}
                      mandatory={mandatory}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                      setWindowSwitch={setWindowSwitch}
                    />
                  ) : testData[questionNo - 1].qtypecode === "2" ? (
                    <MultipleSelectAnswer
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      disable={disable}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                      setWindowSwitch={setWindowSwitch}
                    />
                  ) : testData[questionNo - 1].qtypecode === "16" ||
                    testData[questionNo - 1].qtypecode === "3" ||
                    testData[questionNo - 1].qtypecode === "14" ||
                    testData[questionNo - 1].qtypecode === "18" ||
                    testData[questionNo - 1].qtypecode === "24" ||
                    testData[questionNo - 1].qtypecode === "32" ? (
                    <MultipleanswerAllCorrect
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      disable={disable}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                      setWindowSwitch={setWindowSwitch}
                    />
                  ) : testData[questionNo - 1].qtypecode === "1" ? (
                    <Passage
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      disable={disable}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                      setWindowSwitch={setWindowSwitch}
                    />
                  ) : testData[questionNo - 1].qtypecode === "4" ||
                    testData[questionNo - 1].qtypecode === "5" ||
                    testData[questionNo - 1].qtypecode === "6" ||
                    testData[questionNo - 1].qtypecode === "7" ||
                    testData[questionNo - 1].qtypecode === "8" ||
                    testData[questionNo - 1].qtypecode === "9" ||
                    testData[questionNo - 1].qtypecode === "10" ||
                    testData[questionNo - 1].qtypecode === "25" ? (
                    <DescriptiveAnswer
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      marksScored={marksScored}
                      setMarksScored={setMarksScored}
                      totalMarks={totalMarks}
                      setTotalMarks={setTotalMarks}
                      wrongAnswerCount={wrongAnswerCount}
                      setWrongAnswerCount={setWrongAnswerCount}
                      disable={disable}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                      setWindowSwitch={setWindowSwitch}
                    />
                  ) : testData[questionNo - 1].qtypecode === "19" || testData[questionNo - 1].qtypecode === "29" ? (
                    <TypingTest
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      disable={disable}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                      setWindowSwitch={setWindowSwitch}
                    />
                  ) : testData[questionNo - 1].qtypecode === "15" ? (
                    <DifferenceBetween
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      marksScored={marksScored}
                      setMarksScored={setMarksScored}
                      totalMarks={totalMarks}
                      setTotalMarks={setTotalMarks}
                      wrongAnswerCount={wrongAnswerCount}
                      setWrongAnswerCount={setWrongAnswerCount}
                      disable={disable}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                      setWindowSwitch={setWindowSwitch}
                    />
                  ) : testData[questionNo - 1].qtypecode === "13" ? (
                    <MatchTheColumn
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      marksScored={marksScored}
                      setMarksScored={setMarksScored}
                      totalMarks={totalMarks}
                      setTotalMarks={setTotalMarks}
                      wrongAnswerCount={wrongAnswerCount}
                      setWrongAnswerCount={setWrongAnswerCount}
                      disable={disable}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                      setWindowSwitch={setWindowSwitch}
                    />
                  ) : testData[questionNo - 1].qtypecode === "23" || testData[questionNo - 1].qtypecode === "31" ? (
                    <SpeechEvaluation
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      marksScored={marksScored}
                      setMarksScored={setMarksScored}
                      totalMarks={totalMarks}
                      setTotalMarks={setTotalMarks}
                      wrongAnswerCount={wrongAnswerCount}
                      setWrongAnswerCount={setWrongAnswerCount}
                      disable={disable}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                    />
                  ) : testData[questionNo - 1].qtypecode === "27" ? (
                    <VideoInterview
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      marksScored={marksScored}
                      setMarksScored={setMarksScored}
                      totalMarks={totalMarks}
                      setTotalMarks={setTotalMarks}
                      wrongAnswerCount={wrongAnswerCount}
                      setWrongAnswerCount={setWrongAnswerCount}
                      disable={disable}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                      isRecording={isRecording}
                      setIsRecording={setIsRecording}
                      facialDataArray={facialDataArray}
                      setFacialDataArray={setFacialDataArray}
                      isVideoSent={isVideoSent}
                      setIsVideoSent={setIsVideoSent}
                      isVideoUploading={isVideoUploading}
                      setIsVideoUploading={setIsVideoUploading}
                      facialSentiments={facialSentiments}
                      setFacialSentiments={setFacialSentiments}
                      isTimeUp={isTimeUp}
                      setIsTimeUp={setIsTimeUp}
                      isRecordingDone={isRecordingDone}
                      setIsRecordingDone={setIsRecordingDone}
                      startRecordingCountdown={startRecordingCountdown}
                      setStartRecordingCountdown={setStartRecordingCountdown}
                      recordingVideoRef={recordingVideoRef}
                      sharedCameraStreamRef={sharedCameraStreamRef}
                      recordingOnSharedCameraRef={recordingOnSharedCameraRef}
                    />
                  ) : testData[questionNo - 1].qtypecode === "28" ? (
                    <AutoSpeech
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      marksScored={marksScored}
                      setMarksScored={setMarksScored}
                      totalMarks={totalMarks}
                      setTotalMarks={setTotalMarks}
                      wrongAnswerCount={wrongAnswerCount}
                      setWrongAnswerCount={setWrongAnswerCount}
                      disable={disable}
                      setDisable={setDisable}
                      isRecording={isRecording}
                      setIsRecording={setIsRecording}
                      isVideoSent={isVideoSent}
                      setIsVideoSent={setIsVideoSent}
                      isVideoUploading={isVideoUploading}
                      setIsVideoUploading={setIsVideoUploading}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                      setWindowSwitch={setWindowSwitch}
                    />
                  ) : testData[questionNo - 1].qtypecode === "21" ? (
                    <MultipleFillInTheBlank
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      disable={disable}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                      setWindowSwitch={setWindowSwitch}
                      setWebProcteringZero={setWebProcteringZero}
                    />
                  ) : testData[questionNo - 1].qtypecode === "20" ? (
                    <Simulator
                      testData={testData}
                      questionNo={questionNo}
                      clearFlag={clearFlag}
                      setClearFlag={setClearFlag}
                      examId={examId}
                      setCheckFlag={setCheckFlag}
                      examDetail={examDetail}
                      answerStatus={answerStatus}
                      setAnswerStatus={setAnswerStatus}
                      marksScored={marksScored}
                      setMarksScored={setMarksScored}
                      totalMarks={totalMarks}
                      setTotalMarks={setTotalMarks}
                      wrongAnswerCount={wrongAnswerCount}
                      setWrongAnswerCount={setWrongAnswerCount}
                      disable={disable}
                      setDisable={setDisable}
                      setTestData={setTestData}
                      windowSwitchCount={windowSwitchCount}
                      setWindowSwitch={setWindowSwitch}
                      codeLanguages={codeLanguages}
                    />
                  ) : (
                    <></>
                  )}
                  {/* <hr></hr>
                              {/* <TimePerQuestion testData={testData} questionNo={questionNo}
                          questionChange={questionChange} setQuestionChange={setQuestionChange} />
                          {/* <MultipleSelectAnswer testData={testData} questionNo={questionNo}
                          clearFlag={clearFlag} setClearFlag={setClearFlag} /> */}
                  <Proceed
                    showModel={showModel}
                    isRecording={isRecording}
                    setIsRecording={setIsRecording}
                    startRecordingCountdown={startRecordingCountdown}
                    setStartRecordingCountdown={setStartRecordingCountdown}
                    isVideoSent={isVideoSent}
                    setIsVideoSent={setIsVideoSent}
                    isVideoUploading={isVideoUploading}
                    setIsVideoUploading={setIsVideoUploading}
                    setModelShow={setModelShow}
                    showScore={showscore}
                    showThankyou={showThankyou}
                    setLastQuestionModal={setLastQuestionModal}
                    webProctoring={webProctoring}
                    setProgress={setProgress}
                    progress={progress}
                    questionChange={questionChange}
                    showSubmit={showSubmit}
                    setFinishModal={setFinishModal}
                    setFinishModalDetail={setFinishModalDetail}
                    questionNo={questionNo}
                    setQuestionNo={setQuestionNo}
                    setClearFlag={setClearFlag}
                    testData={testData}
                    examId={examId}
                    checkFlag={checkFlag}
                    setCheckFlag={setCheckFlag}
                    setQuestionChange={setQuestionChange}
                    clearFlag={clearFlag}
                    navFlag={navFlag}
                    selectedOption={
                      testData[questionNo - 1].qtypecode === "28" ||
                        testData[questionNo - 1].qtypecode === "20" ||
                        testData[questionNo - 1].qtypecode === "26" ||
                        testData[questionNo - 1].qtypecode === "12" ||
                        testData[questionNo - 1].qtypecode === "6"
                        ? testData[questionNo - 1].descriptiveText
                        : testData[questionNo - 1].selectedChoiceId
                    }
                    examDetail={examDetail}
                    addNewQuestion={addNewQuestion}
                    disable={disable}
                    mandatory={mandatory}
                    setDisable={setDisable}
                    windowSwitchCount={windowSwitchCount}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* <QuestionNoList themeType={props.themeType} testData={testData}
                          setQuestionNo={setQuestionNo} questionNo={questionNo}
                          setQuestionChange={setQuestionChange} navFlag={navFlag} />

                          <br />

                          <Divider style={{color: 'white'}} />

                          <AnswerUserInfo value={value} />
                      */}
        </div>
      )}
    </>
  );
};
